import { CHART_WIDGET_MODE } from '../../../model/enums';
import { ChartSerieObj } from './chart-serie.obj';
import { WidgetKeyPair } from '@wizeoo/akm-message-lib';
/** objet de configuration d'un chart */
export class ChartConfigObj {
  /** séries de données */
  public dataset: ChartSerieObj[];

  /** type de chart */
  public chartType: CHART_WIDGET_MODE;

  /** la conf */
  public params: WidgetKeyPair[] = null;

  // public animations = true;
  // public showLegend =  true;
  // public showXAxis =  true;
  // public showYAxis =  true;
  // public showGridLines = true;

  /**
   *
   * @param chartype
   * @param dataset
   * @param params la conf du contexte code = val
   */
  constructor(chartype: CHART_WIDGET_MODE, dataset: ChartSerieObj[], params: WidgetKeyPair[] = null) {
    this.chartType = chartype;
    this.dataset = dataset;
    this.params = params;
  }
}
